import React, { useContext, useEffect, useState } from "react";
import SectionIndicator from "../../components/SectionIndicator";
import { SectionIndicatorContext } from "../../shared/contexts/SectionIndicatorContext";
import FooterButtons from "../../components/FooterButtons.";
import { FormProvider, useForm } from "react-hook-form";
import SmsConfirmation from "../../pages/PhoneFlowPswResetPages/SmsConfirmation/SmsConfirmation";
import SetPassword from "../../pages/SetPassword/SetPassword";
import SetPasswordSuccess from "../../pages/SetPassword/SetPasswordSuccess/SetPasswordSuccess";
import PhoneEmailVerification from "../../pages/PhoneFlowPswResetPages/PhoneEmailVerification";
import { getPhoneEmailVerificationDto, getPhoneVerificationDto, getSetPswDto } from "../../shared/utils/dto-mapper";
import { setPassword, smsEmailVerify, smsVerify } from "../../api/api-calls";
import AccountSelect from "../../pages/AccountSelect/AccountSelect";
import Loading from "../../components/Loading/Loading";
import FormLayout from "../../layoutComponents/FormLayout";
import FormLayoutBody from "../../layoutComponents/FormLayout/FormLayoutBody";
import FormLayoutActions from "../../layoutComponents/FormLayout/FormLayoutActions";
import FormLayoutIndicator from "../../layoutComponents/FormLayout/FormLayoutIndicator";
import { Link, Typography } from "@mui/material";
import { baseColors } from "../../theme";
import { getExternalUrls } from "../../configuration/config-external-urls";

const PhoneFlowPswResetLayout = () => {
	const { setSectionNumber, sectionNumber } = useContext(SectionIndicatorContext);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [users, setUsers] = useState<string[]>([]);
	const [isInitAppLoading, setIsInitAppLoading] = useState<boolean>(false);

	useEffect(() => {
		setSectionNumber(3);
	}, []);

	const methods = useForm({
		defaultValues: {
			phoneNumber: "",
			pin: "",
			email: "",
			password: "",
			passwordAgain: "",
		},
	});
	const {
		handleSubmit,
		reset,
		setError,
		setValue,
		formState: { errors },
		watch,
	} = methods;

	function onSubmit(event?: any) {
		event.preventDefault();
		handleSubmit((data: any) => {
			switch (sectionNumber) {
				case 3:
					const phoneVerificationDto = getPhoneVerificationDto(data.pin, data.phoneNumber);
					smsVerify(phoneVerificationDto, setError, setIsLoading, setSectionNumber, "sms-verify");
					break;
				case 4:
					const smsEmailVerificationDto = getPhoneEmailVerificationDto(data.pin, data.phoneNumber, data.email);
					smsEmailVerify(
						smsEmailVerificationDto,
						setValue,
						setUsers,
						setError,
						setIsInitAppLoading,
						setSectionNumber,
						"sms-email-verify"
					);
					break;
				case 5:
					setSectionNumber(6);
					break;
				case 6:
					const pswDTO = getSetPswDto(data.pin, "pin", data.account, data.password);
					setPassword(pswDTO, setError, setIsLoading, setSectionNumber, "set-password");
					break;
				case 2:
				case 7:
					window.open(getExternalUrls().LOGIN_PAGE_URL);
					break;
			}
		})();
	}

	function switchPages(sectionNumber: number | null) {
		switch (sectionNumber) {
			case 3:
				return <SmsConfirmation />;
			case 4:
				return <PhoneEmailVerification />;
			case 5:
				//waits for users account to load
				return users.length > 0 ? <AccountSelect defaultValue={users[0]} users={users} /> : <Loading />;
			case 6:
				return <SetPassword />;
			case 7:
				return <SetPasswordSuccess />;
		}
	}

	return (
		<FormLayout>
			<form style={{ display: "flex", flexDirection: "column", flexGrow: 1 }} onSubmit={onSubmit}>
				{sectionNumber !== 7 && (
					<FormLayoutIndicator>
						<SectionIndicator></SectionIndicator>
					</FormLayoutIndicator>
				)}

				<FormProvider {...methods}>
					<FormLayoutBody>{isInitAppLoading ? <Loading /> : switchPages(sectionNumber)}</FormLayoutBody>
					{/*commented out green success message*/}
					{/*{errors.root?.serverError.type === "success" && (*/}
					{/*	<Alert variant="filled" severity="success" icon={<CheckCircleOutlineIcon color="error" fontSize="large" />}>*/}
					{/*		{errors.root?.serverError.message}*/}
					{/*	</Alert>*/}
					{/*)}*/}
					{errors.root?.serverError.type === "general" && (
						<>
							{errors.root?.serverError.message && errors.root?.serverError.message.includes("RATELIMIT_001") ? (
								<Typography color={baseColors.red} align="center" variant="body1" gutterBottom>
									<p>
										Překročili jste maximální počet pokusů pro obnovu hesla. Opakujte prosím akci o několik minut
										později.
									</p>
									<p>&nbsp;</p>
									<p>
										V případě přetrvávajících potíží s obnovou hesla nás kontaktujte na naší zákaznické lince v
										pracovních dnech od 8 do 18 hodin na čísle{" "}
										<Link color={baseColors.orange} underline="always" tabIndex={-1} href="tel:+420800850860">
											800&nbsp;850&nbsp;860
										</Link>
										.
									</p>
								</Typography>
							) : (
								<Typography color={baseColors.red} align="center" variant="body1" gutterBottom>
									{errors.root?.serverError.message}
								</Typography>
							)}
						</>
					)}
					<FormLayoutActions>
						<FooterButtons
							reset={reset}
							isLoading={isLoading}
							isInitAppLoading={isInitAppLoading}
							watch={watch}
						></FooterButtons>
					</FormLayoutActions>
				</FormProvider>
			</form>
		</FormLayout>
	);
};

export default PhoneFlowPswResetLayout;
